import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css'; // Creeremo questo file CSS

const Navbar = () => {
    const { user, logout } = useAuth();

    return (
        <header className="navbar">
            <div className="navbar-container">
                <Link to="/" className="navbar-logo">
                    {/* Immagine dalla cartella /public */}
                    <img src="/mapp_logo.png" alt="MAPP Logo" />
                    <span>Portale MAPP</span>
                </Link>
                <nav className="navbar-menu">
                    <Link to="/" className="navbar-link">Home</Link>
                    <Link to="/report-passaggi" className="navbar-link">Report Passaggi</Link>
                </nav>
                <div className="navbar-user">
                    <span>Ciao, {user?.name || user?.email}</span>
                    <button onClick={logout} className="button-outline button-small">
                        Logout
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Navbar;